export const GAME_SETTINGS_LOADED = "GAME_SETTINGS_LOADED";
export const GAME_LEVELS_LOADED = "GAME_LEVELS_LOADED";
export const GAME_RECORDS_LOADED = "GAME_RECORDS_LOADED";
export const GAME_LEVEL_REQUEST = "GAME_LEVEL_REQUEST";
export const GAME_LEVEL_COMPLETE = "GAME_LEVEL_COMPLETE";
export const GAME_SCORE_SET = "GAME_SCORE_SET";
export const WORD_BANKS_LOADED = "WORD_BANKS_LOADED";
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const FIRST_PLAY_SET = "FIRST_PLAY_SET";
export const GAME_TIME_LIMITS_SET = "GAME_TIME_LIMITS_SET";
export const GAME_CORRECT_SET = "GAME_CORRECT_SET";
export const GAME_LEVELS_CONSTRUCTED = "GAME_LEVELS_CONSTRUCTED";
export const GAME_SET_DATA = "GAME_SET_DATA";
export const GAME_RANDOMIZED_DATA = "GAME_RANDOMIZED_DATA";
export const GAME_ADD_POINTS = "GAME_ADD_POINTS";
export const GAME_REDUCE_POINTS = "GAME_REDUCE_POINTS";
export const GAME_SET_AVATAR = "GAME_SET_AVATAR";
export const GAME_SET_POINTS = "GAME_SET_POINTS";
export const GAME_SET_BET = "GAME_SET_BET";
export const GAME_SET_BET_LOCK = "GAME_SET_BET_LOCK";
export const GAME_SET_BET_UNLOCK = "GAME_SET_BET_UNLOCK";
export const GAME_SET_FOCUS_LINK_INDEX = "GAME_SET_FOCUS_LINK_INDEX";
export const GAME_SET_ALLOW_HINT_ON_FOCUS_LINK = "GAME_SET_ALLOW_HINT_ON_FOCUS_LINK";
export const GAME_SHOULD_REWARD_POINTS = "GAME_SHOULD_REWARD_POINTS";
export const GAME_STATUS_WON = "GAME_STATUS_WON";
export const GAME_STATUS_LOST = "GAME_STATUS_LOST";
export const GAME_STATUS_QUIT = "GAME_STATUS_QUIT";
export const GAME_STATUS_ACTIVE = "GAME_STATUS_ACTIVE";
export const GAME_STATUS_INACTIVE = "GAME_STATUS_INACTIVE";
export const GAME_STATUS_REVEAL_ALL_ANSWERS = "GAME_STATUS_REVEAL_ALL_ANSWERS";
export const GAME_STATUS_RESET = "GAME_STATUS_RESET";
export const GAME_STATUS_HINT_CLICK = "GAME_STATUS_HINT_CLICK";
export const GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK = "GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK";
export const GAME_STATUS_AWARD_REWARD = "GAME_STATUS_AWARD_REWARD";
export const GAME_SET_STATUS = "GAME_SET_STATUS";
export const GAME_SET_DATA_INDEX = "GAME_SET_DATA_INDEX";
export const GAME_STATUS_START = "GAME_STATUS_START";
export const GAME_STATUS_INSTR_OVERLAY = "GAME_STATUS_INSTR_OVERLAY";
export const GAME_STATUS_REPLAY = "GAME_STATUS_REPLAY";
export const GAME_STATUS_CORRECT_ANSWER = "GAME_STATUS_CORRECT_ANSWER";
export const GAME_STATUS_INCORRECT_ANSWER = "GAME_STATUS_INCORRECT_ANSWER";


export function gameSettingsLoaded(data) {
  return {
    type: GAME_SETTINGS_LOADED,
    data,
  };
}

export function gameLevelsLoaded(data) {
  return {
    type: GAME_LEVELS_LOADED,
    data,
  };
}

export function gameCorrectSet(data) {
  return {
    type: GAME_CORRECT_SET,
    data,
  };
}

export function gameLevelsConstructed(data) {
  return {
    type: GAME_LEVELS_CONSTRUCTED,
    data,
  };
}

export function gameTimeLimitsSet(data) {
  return {
    type: GAME_TIME_LIMITS_SET,
    data,
  };
}

export function wordBanksLoaded(data) {
  return {
    type: WORD_BANKS_LOADED,
    data,
  };
}

export function gameRecordsLoaded(data) {
  return {
    type: GAME_RECORDS_LOADED,
    data,
  };
}

export function gameLevelRequest(data) {
  return {
    type: GAME_LEVEL_REQUEST,
    data,
  };
}

export function gameLevelComplete(data) {
  return {
    type: GAME_LEVEL_COMPLETE,
    data,
  };
}

export function gameScoreSet(data) {
  return {
    type: GAME_SCORE_SET,
    data,
  };
}

export function firstPlaySet(data) {
  return {
    type: FIRST_PLAY_SET,
    data,
  };
}

export function toggleModal(data) {
  return {
    type: TOGGLE_MODAL,
    data,
  };
}

export function setGameData(data) {
  return {
    type: GAME_SET_DATA,
    data,
  };
}

export function setGameDataIndex(data) {
  return {
    type: GAME_SET_DATA_INDEX,
    data,
  };
}

export function randomizedGameData(data) {
  return {
    type: GAME_RANDOMIZED_DATA,
    data,
  };
}

export function addGamePoints(data) {
  return {
    type: GAME_ADD_POINTS,
    data,
  };
}

export function reduceGamePoints(data) {
  return {
    type: GAME_REDUCE_POINTS,
    data,
  };
}

export function setGameAvatar(data) {
  return {
    type: GAME_SET_AVATAR,
    data,
  };
}

export function setGamePoints(data) {
  return {
    type: GAME_SET_POINTS,
    data,
  };
}

export function setGameBet(data) {
  return {
    type: GAME_SET_BET,
    data,
  };
}

export function setGameBetLock(data) {
  return {
    type: GAME_SET_BET_LOCK,
    data,
  };
}

export function setGameBetUnlock(data) {
  return {
    type: GAME_SET_BET_UNLOCK,
    data,
  };
}

export function setGameFocusLinkIndex(data) {
  return {
    type: GAME_SET_FOCUS_LINK_INDEX,
    data,
  };
}

export function setIsAllowHintOnFocusLink(data) {
  return {
    type: GAME_SET_ALLOW_HINT_ON_FOCUS_LINK,
    data,
  };
}

export function setShouldRewardPoints(data) {
  return {
    type: GAME_SHOULD_REWARD_POINTS,
    data,
  };
}

export function setGameStatus(data) {
  return {
    type: GAME_SET_STATUS,
    data,
  };
}

export function resetGameStatus() {
  return {
    type: GAME_SET_STATUS,
    data: null,
  };
}

export function setGameWonStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_WON,
  };
}

export function setGameLostStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_LOST,
  };
}

export function setGameActiveStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_ACTIVE,
  };
}

export function setGameInactiveStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_INACTIVE,
  };
}

export function setGameQuitStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_QUIT,
  };
}

export function setGameRevealAllAnswersStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_REVEAL_ALL_ANSWERS,
  };
}

export function setGameRevealAllAnswersClickStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK,
  };
}

export function setGameHintStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_HINT_CLICK,
  };
}

export function setGameAwardRewardStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_AWARD_REWARD,
  };
}

export function setGameStartStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_START,
  };
}

export function setGameIncorrectAnswerStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_INCORRECT_ANSWER,
  };
}

export function setGameCorrectAnswerStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_CORRECT_ANSWER,
  };
}

export function setGameReplayStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_REPLAY,
  };
}

export function setGameInstrOverlayStatus() {
  return {
    type: GAME_SET_STATUS,
    data: GAME_STATUS_INSTR_OVERLAY,
  };
}